module.exports = __webpack_public_path__ + "img/30.aa4d317b.jpg";